import { FC, ReactNode } from 'react';
import Flex from '../../Flex';

type Props = {
  children?: ReactNode;
  vertical?: boolean;
  align?: 'center' | 'start' | 'end' | 'baseline' | 'stretch';
  gap?: number;
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
  style?: object;
  manualSize?: boolean;
};

export const TwinBox: FC<Props & { vertical?: boolean }> = (props: any) => {
  return (
    <Flex
      {...props}
      vertical={props.vertical}
      gap={props.gap}
      justify={props.justify || 'space-between'}
      align={props.align || 'stretch'}
      style={{
        [!props.manualSize ? (props.vertical ? 'height' : 'width') : '']: '100%',
        ...props.style,
      }}
    >
      {props.children}
    </Flex>
  );
};

export default TwinBox;
